import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { HighchartsProvider } from 'react-highcharts-wrapper';
import treemap from 'highcharts/modules/treemap';
import drilldown from 'highcharts/modules/drilldown';
import highchartsMore from 'highcharts/highcharts-more';
import highchartsExporting from 'highcharts/modules/exporting';
import exportData from 'highcharts/modules/export-data';
import map from 'highcharts/modules/map';
import moment from 'moment';
import { get } from 'lodash';

import OnMountHomeScroll from 'hoc/OnMountHomeScroll';
import { Footer } from '@goodwaygroup/ui-ux';
import { setHighchartsOptions } from 'helpers/charts';


const Wrapper = styled.div``;

const Header = styled.header``;

const SideBar = styled.div``;

const Title = styled.div``;

const Content = styled.div`

    margin:  ${props => (props.hideHeaderSpace ? '75px' : '150px')} 25px 0;

    ${breakpoint('xs', 'md')`
        margin: ${props => (props.hideHeaderSpace ? '75px' : '5px')} 5px 0;
    `}

`;

const OuterContentWrapper = styled.div`
    float: right;
    min-height: calc(100vh - 100px);

    ${breakpoint('xs', 'md')`
        width: 100%;
    `}

    ${breakpoint('md', 'xl')`
        width:calc(100% - 200px);
    `}

    position: relative;

    @media print {
        float: inherit;
        width: 100%;
    }
`;

const DashboardTemplate = ({
    header,
    sidebar,
    title,
    children,
    ...props
}) =>
    <Wrapper {...props}>
        <Header>{header}</Header>
        <SideBar>{sidebar}</SideBar>
        <OuterContentWrapper>
            <Title>{title}</Title>
            <Content {...props}>
                <HighchartsProvider executeFuncs={[
                    setHighchartsOptions,
                    drilldown,
                    treemap,
                    highchartsMore,
                    highchartsExporting,
                    exportData,
                    map,
                ]}>
                    {children}
                </HighchartsProvider>
            </Content>
            {get(props.theme, 'whitelabel.showGGBranding', true) &&
                <Footer year={moment().year()} theme={props.theme} />}
        </OuterContentWrapper>
    </Wrapper>;

DashboardTemplate.propTypes = {
    header: PropTypes.node.isRequired,
    footer: PropTypes.node,
    title: PropTypes.node,
    children: PropTypes.any.isRequired,
};

export default OnMountHomeScroll()(withTheme(DashboardTemplate));



// WEBPACK FOOTER //
// ./src/components/templates/Dashboard.js